import { Controller } from "@hotwired/stimulus"
import { sendJSON } from "../api.js"

// Serduszko ulubionej podkategorii w sidebarze katalogu.
// Kliknięcie przełącza subskrypcję backorder (toggle endpoint): wypełnione = zapisane, kontur = nie.
// Optymistyczny UI: stan zmienia się natychmiast; nieudany request cofa zmianę.
const TOGGLE_URL = "/api/backorder-subscriptions/toggle/"

/** @param {boolean} active */
function heartChar(active) {
  return active ? "♥" : "♡"
}

export default class extends Controller {
  static values = {
    /** Id podkategorii (liczba) — wysyłane w body żądania toggle. */
    subcategoryId: Number,
    /** Czy subskrypcja jest aktywna (stan wyjściowy renderowany przez kontroler katalogu). */
    active: Boolean,
  }

  connect() {
    this.#render()
  }

  activeValueChanged() {
    this.#render()
  }

  /** Przełącza stan serduszka (dodaj / usuń z ulubionych). */
  async toggle() {
    const wasActive = this.activeValue
    // Optymistyczna zmiana — widoczna natychmiast
    this.activeValue = !wasActive

    const res = await sendJSON("POST", TOGGLE_URL, { subcategory: this.subcategoryIdValue })

    if (!res.ok) {
      // Cofnij, jeśli API zwróciło błąd
      this.activeValue = wasActive
      return
    }
    // Potwierdź stan na podstawie odpowiedzi API
    if (res.status === 201) {
      this.activeValue = true
    } else if (res.status === 204) {
      this.activeValue = false
    }
  }

  // --- prywatne ---

  #render() {
    const active = this.activeValue
    this.element.textContent = heartChar(active)
    this.element.setAttribute("aria-pressed", String(active))
    this.element.setAttribute("aria-label", active ? "Usuń z ulubionych" : "Dodaj do ulubionych")
  }
}
